import { Record, List, Map } from 'immutable';

export const SORT_TYPE = {
  ASC: 'asc',
  DESC: 'desc',
};

const defaultValues = {
  updating: false,
  loading: false,
  filtersLoading: false,
  errorMessage: null,
  sortKey: null,
  sortType: null,
  filters: new Map(),
  options: new Map(),
  data: new List(),
};

export default class BaseList extends Record(defaultValues, BaseList) {
  constructor(values) {
    super({
      ...values,
      filters: values && values.filters ? values.filters : defaultValues.filters,
    });
  }

  getFiltersAsQueryString(excludedKeys) {
    const blackList = Array.isArray(excludedKeys) ? excludedKeys : [];
    let result = '';
    let index = 0;
    this.filters.forEach((value, key) => {
      if (blackList.includes(key) === false) {
        if (index === 0) {
          result += `?${ key }=${ value }`;
        } else {
          result += `&${ key }=${ value }`;
        }
        index++;
      }
    });
    return result;
  }

  getFiltersAsPartialQueryString(excludedKeys) {
    const blackList = Array.isArray(excludedKeys) ? excludedKeys : [];
    let result = '';
    this.filters.forEach((value, key) => {
      if (blackList.includes(key) === false) {
        result += `&${ key }=${ value }`;
      }
    });
    return result;
  }

  setOption(key, value) {
    return this.options.set(`${ key }`, value);
  }

  deleteOption(key) {
    return this.options.delete(`${ key }`);
  }
}
